/* import __COLOCATED_TEMPLATE__ from './fin-tasks-ai-generated-procedure-modal.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    model: {
      isOpen: boolean;
      onClose: () => void;
    };
  };
}

const FinTasksAiGeneratedProcedureModal = templateOnlyComponent<Signature>();
export default FinTasksAiGeneratedProcedureModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::Workflows::FinTasksAiGeneratedProcedureModal': typeof FinTasksAiGeneratedProcedureModal;
    'react/workflows/fin-tasks-ai-generated-procedure-modal': typeof FinTasksAiGeneratedProcedureModal;
  }
}
